export default __webpack_public_path__ + "images/3ccea03c7cbf51c09cfda87cb35fd7ec.png";